module.exports = __webpack_public_path__ + "img/konb.292118ca.png";